import { Component, createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import { Ncs, PartialNcsConfig, mergePartialConfigs } from 'ncs'
import { ncsConfig } from '../search/ncs_config'
import App from '../search/Form.vue'
import PageSelector from "../search/PageSelector.vue"
import KwicHeader from '../search/KwicHeader.vue'
import ContextResult from '../search/ContextResult.vue'
import ContextTextHeader from '../search/ContextTextHeader.vue'
import ContextTextTitle from '../search/ContextTextTitle.vue'
import MatchingExpressionsPageSelector from '../search/MatchingExpressionsPageSelector.vue'

declare global {
  interface Window {
    gon: any
  }
}

const components: Record<string, Component> = {
  NcsPageSelector: PageSelector,
  NcsKwicResultHeader: KwicHeader,
  NcsContextResult: ContextResult,
  NcsContextTextHeader: ContextTextHeader,
  NcsContextTextTitle: ContextTextTitle,
  NcsMatchingExpressionsPageSelector: MatchingExpressionsPageSelector,
}

const serverConfig = window.gon.config as PartialNcsConfig
const config = mergePartialConfigs(serverConfig, ncsConfig)

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: serverConfig.i18n.locale,
  messages: { [config.i18n.locale]: config.i18n.messages }
})

const mountApplication = () => {
  const main = document.getElementById('search')
  if (!main) return

  const pinia = createPinia()
  const app = createApp(App)
    .use(i18n)
    .use(pinia)
    .use(Ncs, { config, components })

  const el = main.appendChild(document.createElement('div'))
  app.mount(el)

  document.addEventListener('turbo:before-cache', () => app.unmount(), { once: true })
}

document.addEventListener('turbo:render', mountApplication)

mountApplication() // Trigger when script is first loaded
